import React from 'react';
import { DialogActions, DialogContent } from '@mui/material';
import Box from '@mui/material/Box';
import { useTranslation } from 'next-i18next';

import dynamic from 'next/dynamic';

import DialogTitle from 'src/components/ui/DialogTitle';
import Typography from 'src/components/ui/Typography';
import Button from 'src/components/ui/Button';

import { styledComponent } from 'src/utils/styled';
import { colours } from 'src/constants/colours';

const TutorialPointingArrow = dynamic(() => import('src/assets/misc/pointing-arrow.svg'), {
    ssr: false,
});

const StyledTutorialPointingArrow = styledComponent(TutorialPointingArrow)`
    z-index: 1400;
    width: 4.5rem;
    height: 5rem;
`;

const ContentBox = styledComponent(Box)`
    border-radius: 0.25rem;
    background-color: ${colours.white.main};
    display: flex;
    flex-direction: column;
    width: 17.5rem;
    height: 13.125rem;
    .MuiDialogContent-root {
        padding: 0 1.5rem;
    }
    .MuiDialogActions-root {
        padding: 0 1.5rem 1.5rem 1.5rem;
    }
    .MuiDialogTitle-root {
        padding: 1.5rem 1.5rem 0.5rem 1.5rem;
    }
`;

type Props = {
    handleCloseTutorial: () => void;
};

const SavedSearchesTutorialPopover: React.FC<Props> = ({ handleCloseTutorial }) => {
    const { t } = useTranslation(['common', 'ad']);
    return (
        <Box
            display="flex"
            flexDirection="column"
            zIndex="1400"
            style={{ backgroundColor: 'transparent' }}
            paddingRight="1rem"
        >
            <Box
                display="flex"
                flexDirection="row"
                justifyContent="flex-end"
                style={{ backgroundColor: 'transparent' }}
                marginBottom="1rem"
            >
                <StyledTutorialPointingArrow />
            </Box>
            <ContentBox>
                <DialogTitle onClose={handleCloseTutorial}>
                    <Typography variant="h3">{t('ad:savedInTheBox')}</Typography>
                </DialogTitle>
                <DialogContent>
                    <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
                        <Box mt="1rem">
                            <Typography variant="body2">{t('ad:savedSearchesTutorial')}</Typography>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseTutorial}>{t('common:understood')}</Button>
                </DialogActions>
            </ContentBox>
        </Box>
    );
};

export default SavedSearchesTutorialPopover;
